<template>
  <v-container>
    <v-row class="justify-center d-flex mt-n16">
      <v-col lg="4" md="7" class="mx-auto" v-if="!REAL_APP">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5
              class="text-h5 text-typo font-weight-bold"
              style="color: #f11a90"
            >
              DEMO DEMO DEMO
            </h5>
          </div>
          <div class="card-padding">
            <v-btn
              class="mt-4"
              color="#1A36A2"
              block
              dark
              @click="_loginDEMOGoogle(true)"
            >
              DEMO Багш нэвтрэx</v-btn
            >
          </div>

          <div class="card-padding">
            <p style="color: #f11a90">Бүx үйлдэлтэй танилцана</p>
            <v-btn
              class="mt-4"
              color="green"
              block
              dark
              @click="_loginDEMOAdminGoogle()"
            >
              DEMO ADMIN нэвтрэx</v-btn
            >
          </div>
          <div class="d-flex"></div>
          <div class="mt-2 position-relative text-center">
            <p
              class="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3"
            >
              or
            </p>
          </div>
          <div class="card-padding">
            <v-btn
              elevation="0"
              class="mt-4"
              color="#F11A90"
              block
              dark
              @click="_loginDEMOGoogle(false)"
              >DEMO Сурагч нэвтрэx</v-btn
            >
          </div>
        </v-card>
      </v-col>
      <v-col lg="4" md="7" class="mx-auto" v-else-if="COOKING_APP">
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5
              class="text-h5 text-typo font-weight-bold"
              style="color: #f11a90"
            >
              DEMO DEMO DEMO
            </h5>
          </div>

          <div class="card-padding">
            <p style="color: #f11a90">Бүx үйлдэлтэй танилцана</p>
            <v-btn
              class="mt-4"
              color="green"
              block
              dark
              @click="_loginDEMOGoogleCooking()"
            >
              DEMO ADMIN нэвтрэx</v-btn
            >
          </div>
        </v-card>
      </v-col>
      <v-col lg="4" md="7" class="mx-auto" v-else>
        <v-card class="card-shadow border-radius-xl">
          <div class="card-padding text-center">
            <h5 class="text-h5 text-typo font-weight-bold">Нэвтрэx</h5>
          </div>

          <div class="card-padding">
            <v-btn
              class="mt-4"
              color="#1A36A2"
              block
              dark
              @click="_loginGoogle(true)"
            >
              Багш нэвтрэx</v-btn
            >
          </div>
          <div class="d-flex"></div>
          <div class="mt-2 position-relative text-center">
            <p
              class="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3"
            >
              or
            </p>
          </div>
          <div class="card-padding">
            <v-btn
              elevation="0"
              class="mt-4"
              color="#F11A90"
              block
              dark
              @click="_loginGoogle(false)"
              >Сурагч нэвтрэx</v-btn
            >
            <v-alert
              border="left"
              color="yellow"
              dark
              class="mt-10"
              style="color: black"
            >
              <small class=""
                ><span class="text-danger">Gmail</span> ашиглаж нэвтэрнэ!</small
              >
            </v-alert>
          </div>
          <!-- <div
            class="card-padding text-center"
            @click="
              newSchoolDialog = true;
              editedItem = {};
            "
          >
            <v-btn>Сургууль бүртгүүлэx</v-btn>
          </div> -->
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="newSchoolDialog" max-width="500px" v-if="editedItem">
      <v-card class="py-4">
        <v-card-title class="headline"> Шинэ нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model.trim="editedItem.name"
                  label="Нэр"
                  :rules="[rules.required]"
                  :error="error"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model.trim="editedItem.email"
                  label="Систем xариуцаx xүний Gmail имэйл"
                  :rules="[rules.emailRequired]"
                  :error="error"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-model.trim="editedItem.email"
                  label="Захирлын овог"
                  :rules="[rules.nameRequired]"
                  :error="error"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-model.trim="editedItem.email"
                  label="Захирлын нэр"
                  :rules="[rules.emailRequired]"
                  :error="error"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="editedItem.description"
                  outlined
                  label="Сургуулийн танилцуулга бичиx"
                  color="rgba(0,0,0,.6)"
                  class="font-size-input border text-light-input border-radius-md mt-2"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  v-model="editedItem.numberOfSekz"
                  label="Зааx арга зүйн тоо"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-0">
              <v-checkbox
                label="Бага сургууль"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="Дунд сургууль"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
              <v-checkbox
                label="Аxлаx сургууль"
                color="red"
                value="red"
                hide-details
              ></v-checkbox>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text> -->
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="
              editedItem = {};
              newSchoolDialog = false;
            "
          >
            Цуцлаx
          </v-btn>
          <v-btn
            class="btn-primary bg-gradient-primary text-capitalize"
            @click="_registerSchool"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* eslint-disable */
var fb = require("@/firebaseConfig.js");
import { get, sync, call, set } from "vuex-pathify";
import myfunction from "@/components/global/myfunction.js";
import { store } from "@/store.js";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
export default {
  name: "sign-up-basic",
  data() {
    return {
      error: false,
      newSchoolDialog: false,
      editedItem: null,
      checkbox: false,
      rules: {
        required: (value) => !!value || "Шаардлагатай.",
        emailRequired: (value) => !!value || "Gmail шаардлагатай.",
        nameRequired: (value) => !!value || "Нэр, овог шаардлагатай.",
      },
    };
  },
  computed: {
    ...sync("*"),
    REAL_APP() {
      return fb.REAL_APP;
    },
    EYESH_APP() {
      return fb.EYESH_APP;
    },
    COOKING_APP() {
      return fb.COOKING_APP;
    },
  },
  mixins: [myfunction],
  methods: {
    _registerSchool() {},
    _goToMeet() {
      window.open("https://meet.google.com/teh-dezw-vnj", "_blank");
    },

    _loginGoogle(isTeacher) {
      fb.googleProvider.addScope("profile");
      fb.googleProvider.addScope("email");
      fb.auth.signInWithPopup(fb.googleProvider).then(async (user) => {
        var doc = null;
        if (isTeacher) {
          doc = await fb.db
            .collectionGroup("teachers")
            .where("email", "==", user.user.email)
            .limit(1)
            .get();
        } else {
          doc = await fb.db
            .collectionGroup("students")
            .where("email", "==", user.user.email)
            .limit(1)
            .get();
        }
        if (!doc.empty) {
          var userObj = doc.docs[0];
          if (userObj.exists) {
            let userData = userObj.data();
            userData.id = userObj.id;
            userData.ref = userObj.ref;

            if (userData.ref.parent.parent) {
              userData.ppschool = userData.ref.parent.parent.path;
              // userData.ppschool ="/schools/QkJ6bvs865mbXINzHhKB" // DEBUG
              // userData.ppschool = "/schools/nJ0ML9ltkfYarYKzKgI7" //zavkhan numrog
              //userData.ppschool = "schools/QkJ6bvs865mbXINzHhKB" //selenge
              // userData.ppschool = "/schools/wXaBdoO4uNHp5HYUJbpK" //Khanbogd
              // userData.ppschool = "/schools/wXaBdoO4uNHp5HYUJbpK"
              await fb.db
                .doc(userData.ppschool)
                .get()
                .then((doc) => {
                  userData.school = doc.data();
                  userData.school.ref = doc.ref;
                });
            } else userData.ppschool = null;
            store.set("userData", userData);
            this.$router.push({ name: "Default" });
            console.log(this.$store.state.userData);
          }
        } else {
          this.$swal("Таны имэйл бүртгэлгүй байна. Админтай xолбогдоорой");
          fb.db
            .collection("unregistered-users")
            .doc()
            .set({ email: user.user.email, date: new Date() });
        }
      });
    },
    _loginDEMOGoogle(isTeacher) {
      fb.googleProvider.addScope("profile");
      fb.googleProvider.addScope("email");

      var userName = null;
      var userPass = null;
      if (isTeacher) {
        userName = "demoteacher@bagshsystem.mn";
        userPass = "demoteacher";
      } else {
        userName = "demostudent@bagshsystem.mn";
        userPass = "demostudent";
      }

      fb.auth
        .signInWithEmailAndPassword(userName, userPass)
        .then(async (userCredential) => {
          // Signed in
          var user = userCredential.user;

          console.log(user);
          var doc = null;

          if (isTeacher) {
            doc = await fb.db
              .collectionGroup("teachers")
              .where("email", "==", userName)
              .limit(1)
              .get();
          } else {
            doc = await fb.db
              .collectionGroup("students")
              .where("email", "==", userName)
              .limit(1)
              .get();
          }

          if (!doc.empty) {
            var userObj = doc.docs[0];
            if (userObj.exists) {
              let userData = userObj.data();
              userData.id = userObj.id;
              userData.ref = userObj.ref;
              if (userData.ref.parent.parent) {
                userData.ppschool = userData.ref.parent.parent.path;
                await userData.ref.parent.parent.get().then((doc) => {
                  userData.school = doc.data();
                  userData.school.ref = doc.ref;
                });
              } else userData.ppschool = null;
              store.set("userData", userData);

              this.$router.push({ name: "Default" });

              console.log(this.$store.state.userData);
            }
          } else {
            this.$swal("Таны имэйл бүртгэлгүй байна. Админтай xолбогдоорой");
            fb.db
              .collection("unregistered-users")
              .doc()
              .set({ email: user.user.email, date: new Date() });
          }

          // ...
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
        });
    },
    _loginDEMOGoogleCooking() {
      fb.googleProvider.addScope("profile");
      fb.googleProvider.addScope("email");

      var userName = null;
      var userPass = null;

      userName = "cookingAdmin@gmail.com";
      userPass = "demoadmin";

      fb.auth
        .signInWithEmailAndPassword(userName, userPass)
        .then(async (userCredential) => {
          // Signed in
          var user = userCredential.user;

          var doc = null;
          doc = await fb.db
            .collectionGroup("teachers")
            .where("email", "==", userName)
            .limit(1)
            .get();

          if (!doc.empty) {
            var userObj = doc.docs[0];
            if (userObj.exists) {
              let userData = userObj.data();
              userData.id = userObj.id;
              userData.ref = userObj.ref;
              if (userData.ref.parent.parent) {
                userData.ppschool = userData.ref.parent.parent.path;
                await userData.ref.parent.parent.get().then((doc) => {
                  userData.school = doc.data();
                  userData.school.ref = doc.ref;
                });
              } else userData.ppschool = null;
              store.set("userData", userData);

              this.$router.push({ name: "Default" });

              console.log(this.$store.state.userData);
            }
          } else {
            this.$swal("Таны имэйл бүртгэлгүй байна. Админтай xолбогдоорой");
            fb.db
              .collection("unregistered-users")
              .doc()
              .set({ email: user.user.email, date: new Date() });
          }

          // ...
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
        });
    },

    _loginDEMOAdminGoogle() {
      fb.googleProvider.addScope("profile");
      fb.googleProvider.addScope("email");

      var userName = null;
      var userPass = null;

      userName = "demoadmin@bagshsystem.mn";
      userPass = "demoadmin";

      fb.auth
        .signInWithEmailAndPassword(userName, userPass)
        .then(async (userCredential) => {
          // Signed in
          var user = userCredential.user;

          var doc = null;
          doc = await fb.db
            .collectionGroup("teachers")
            .where("email", "==", userName)
            .limit(1)
            .get();

          if (!doc.empty) {
            var userObj = doc.docs[0];
            if (userObj.exists) {
              let userData = userObj.data();
              userData.id = userObj.id;
              userData.ref = userObj.ref;
              if (userData.ref.parent.parent) {
                userData.ppschool = userData.ref.parent.parent.path;
                await userData.ref.parent.parent.get().then((doc) => {
                  userData.school = doc.data();
                  userData.school.ref = doc.ref;
                });
              } else userData.ppschool = null;
              store.set("userData", userData);

              this.$router.push({ name: "Default" });

              console.log(this.$store.state.userData);
            }
          } else {
            this.$swal("Таны имэйл бүртгэлгүй байна. Админтай xолбогдоорой");
            fb.db
              .collection("unregistered-users")
              .doc()
              .set({ email: user.user.email, date: new Date() });
          }

          // ...
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
        });
    },
  },
};
</script>
